import { getCookie, setCookie, delete_cookie } from "./cookieManager";

const AUTH_TOKEN_KEY = 'profile_token';
export const AUTH_SYNC_KEY = 'cleanbee_auth_sync';

class AuthService {
    getAuthToken(): string|null {
        const cookieToken = getCookie(AUTH_TOKEN_KEY);
        if (cookieToken) return cookieToken;
        try {
            return localStorage.getItem(AUTH_TOKEN_KEY) || localStorage.getItem("token") || null;
        } catch {
            return null;
        }
    }
    setAuthToken(token: string) {
        setCookie(AUTH_TOKEN_KEY, token);
        try {
            localStorage.setItem(AUTH_TOKEN_KEY, token);
            localStorage.setItem("token", token);
            localStorage.setItem(AUTH_SYNC_KEY, JSON.stringify({ token, timestamp: Date.now() }));
        } catch (e) {}
    }
    clearAuthToken() {
        delete_cookie(AUTH_TOKEN_KEY);
        try {
            localStorage.removeItem(AUTH_TOKEN_KEY);
            localStorage.removeItem("token");
            localStorage.setItem(AUTH_SYNC_KEY, JSON.stringify({ token: null, timestamp: Date.now() }));
        } catch (e) {}
    }
    getAuthHeader() {
        return {
            "Authorization": `Bearer ${this.getAuthToken()}`
        }
    }
}

export default new AuthService();